/**
 * 加盟店 identity for the FCオーナー portal.
 *
 * The 拠点 list, their codes and their KPI live in
 * `services/main/clinicScope.ts` — that is data, and will come from the API.
 */
export const OWNER_FRANCHISE_NAME = 'はなみずき加盟店';
